import { useTranslation } from "react-i18next";

export default function AboutModal({ isOpen, onClose }) {
    const { t } = useTranslation();

    if (!isOpen) return null;

    return (
        <div className="modal show">
            <div className="modal-backdrop" onClick={onClose}></div>

            <div className="modal-card" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>✕</button>

                <h2>{t("about.title")}</h2>

                <p>
                    {t("about.p1")}
                    <em>{t("about.p1_em")}</em>
                </p>

                <p>{t("about.p2")}</p>
                <p>{t("about.p3")}</p>

                <p className="modal-footer">
                    {t("about.contact")}<br />
                    <a href="mailto:support@ninoa.space">support@ninoa.space</a>
                </p>
            </div>
        </div>
    );
}
